function capitalizeFirstLetter(str) {
  if (str.length === 0) {
    return str;
  } else {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

function stripHtml(value) {
  if (typeof value !== "string" || !/[<>]/.test(value)) return value;
  return value
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, "")
    .replace(/<\/?[^>]+>/g, "")
    .trim();
}

const ORDER_PII_FIELDS = [
  "firstname",
  "lastname",
  "street",
  "street2",
  "city",
  "company",
  "other",
  "alias",
  "remark",
  "vat_code",
  "postal_code",
  "phone",
];

function sanitizePiiObject(obj) {
  if (!obj || typeof obj !== "object") return obj;
  let clone = null;
  for (const key of ORDER_PII_FIELDS) {
    const cleaned = stripHtml(obj[key]);
    if (cleaned !== obj[key]) {
      clone = clone || { ...obj };
      clone[key] = cleaned;
    }
  }
  return clone || obj;
}

function sanitizeOrderPII(order) {
  if (!order || typeof order !== "object") return order;
  const patch = {};
  let changed = false;
  for (const key of [
    "shipping_address",
    "billing_address",
    "org_billing_address",
    "customer",
  ]) {
    const cleaned = sanitizePiiObject(order[key]);
    if (cleaned !== order[key]) {
      patch[key] = cleaned;
      changed = true;
    }
  }
  return changed ? { ...order, ...patch } : order;
}

export { capitalizeFirstLetter, stripHtml, sanitizeOrderPII };
